import { useServiceStore, useUserService } from "..";
export function usePermission(permission) {
    const UserService = useUserService();
    return useServiceStore(UserService, (state) => state.permissions.includes(permission));
}
//# sourceMappingURL=usePermission.js.map